// extracted by mini-css-extract-plugin
export default {"root":"_3E8iL"};